import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Paper,
  Grid,
  Typography,
  useMediaQuery
} from '@material-ui/core';

/**Connections */
import { isUndefined, isNull } from 'lodash';
import { uploadContentService } from '../../../services';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { CircularProgress } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Navbar from '../../../components/Navbar';


const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    marginTop: 15,
    maxWidth: '100%',
    padding: 25,
  },
  inputM: {
    width: "50%"
  },
  inputNM: {
    width: "98%",
    marginLeft: 15,
  },
  paper: {
    padding: theme.spacing(1),
    backgroundColor: '#252525',
    color: theme.palette.text.secondary,
  },
  textDesign: {
    textAlign: 'left',
    color: '#ff5722',
    fontSize: 30,
  },
  textDesign1: {
    textAlign: 'left',
    fontSize: 14,
    color: '#ffffff',
  },
  textDesign2: {
    textAlign: 'right',
    fontSize: 14,
    color: '#ffffff',
    marginTop: 15,
    marginRight: 30,
  },
  text1: {
    textAlign: 'left',
    fontSize: 14,
    color: '#ffffff',
    marginTop: 15,
    marginLeft: 10,
  },
  toggleGroup: {
    backgroundColor: "#FFF",
    margin: 10,
    height: 35,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '95%',
    backgroundColor: '#FFF',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  }
}));

export default function TaggedPlaylistDetailView() {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const id = location.state.id;

  const [view, setView] = useState('list');
  const [inputDD, setInputDD] = useState('');
  const [inputDD1, setInputDD1] = useState('');
  const [inputDD2, setInputDD2] = useState('');

  const { user } = useSelector(state => state.userAuthentication);
  const [taggedPlaylist, setTaggedPlaylist] = useState({});


  const getTaggedPlaylist = useCallback(async () => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.taggedPlaylistDetail(user, id);
      setTaggedPlaylist(res);
    }
  }, [user, id]);

  useEffect(() => {
    getTaggedPlaylist();
  }, [getTaggedPlaylist]);

  const handleChangeToggle = (event, nextView) => {
    setView(nextView);
  };
  const handleChangeSelect = (event) => {
    setInputDD(event.target.value);
  };
  const handleChangeSelect1 = (event) => {
    setInputDD1(event.target.value);
  };
  const handleChangeSelect2 = (event) => {
    setInputDD2(event.target.value);
  };

  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <>
      <Navbar></Navbar>
      {!isUndefined(taggedPlaylist) && !isNull(taggedPlaylist) ? (
        <Grid className={classes.root} justify="center" container item >
          <Grid item xs={12} >
            <Paper className={classes.paper} >
              <Typography className={classes.textDesign}>Media Rules</Typography>
              <Grid container spacing={5} >
                <Grid item xs={12} md={6}>
                  <p className={classes.textDesign1}>Match
                    <ToggleButtonGroup className={classes.toggleGroup} orientation="horizontal" value={view} exclusive onChange={handleChangeToggle}>
                      <ToggleButton value="list" aria-label="list">
                        All
                      </ToggleButton>
                      <ToggleButton value="module" aria-label="module">
                        Any
                      </ToggleButton>
                    </ToggleButtonGroup>
                    <strong style={{ color: "#fb8c00" }}>Media</strong> tagged as follows:
                  </p>
                </Grid>
                <Grid item xs={12} md={6}>
                  <p className={classes.textDesign2}>TTL:
                    <input className={isMobile ? classes.inputM : classes.inputNM} />
                  </p>
                </Grid>
              </Grid>
              <Grid container spacing={5} style={{ textAlign: "left" }}>
                <Grid item xs={12} md={4}>
                  <strong style={{ color: "#FFF", fontSize: 14 }}>Tag Name</strong>
                  <Paper className={classes.paper}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={inputDD}
                        onChange={handleChangeSelect}>
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={10}>IV-28</MenuItem>
                        <MenuItem value={20}>IV-29</MenuItem>
                        <MenuItem value={30}>IV-25</MenuItem>
                      </Select>
                    </FormControl>
                    {/* <Paper className={classes.paper} elevation={1}>
                      text Lorem
                    </Paper> */}
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Paper className={classes.paper}>
                    <strong style={{ color: "#FFF", fontSize: 14 }}>Condition</strong>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={inputDD1}
                        onChange={handleChangeSelect1} >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={10}>Is</MenuItem>
                        <MenuItem value={20}>IsNot</MenuItem>
                        <MenuItem value={30}>ContainsAll</MenuItem>
                        <MenuItem value={40}>ContainsAny</MenuItem>
                        <MenuItem value={50}>Contains</MenuItem>
                        <MenuItem value={60}>DoesNotContain</MenuItem>
                        <MenuItem value={70}>BeginsWith</MenuItem>
                        <MenuItem value={80}>EndsWith</MenuItem>
                        <MenuItem value={90}>IsIn</MenuItem>
                        <MenuItem value={100}>IsNotIn</MenuItem>
                      </Select>
                    </FormControl>
                    {/* <Paper className={classes.paper} elevation={1}>
                      text Lorem
                    </Paper> */}
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Paper className={classes.paper}>
                    <strong style={{ color: "#FFF", fontSize: 14 }}>Value (required)</strong>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={inputDD2}
                        onChange={handleChangeSelect2}>
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={10}>Required1</MenuItem>
                        <MenuItem value={20}>Required2</MenuItem>
                        <MenuItem value={30}>Required3</MenuItem>
                      </Select>
                    </FormControl>
                    {/* <Paper className={classes.paper} elevation={1}>
                      text Lorem
                    </Paper> */}
                  </Paper>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      ) : (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      )}
    </>
  )
}